import CustomerScoreCard from "@dana/Components/CustomerScoreCard/CustomerScoreCard";
import { MappedLink, MenuItemText } from "@dana/Components/DanaMenu/DanaMenu";
import ShowPriceSettingSwitch from "@dana/Components/DanaMenu/ShowPriceSettingSwitch";
import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontWeights } from "@dana/MobiusOverrides/styles/typography";
import {
    checkCustomerScorecard,
    checkLeadTimes,
    checkPriceList,
    DanaCoopData,
    DanaCoreReturnsData,
    downloadLeadTimes,
    downloadPriceList,
    getCoopToken,
    getCoreReturnsToken,
    getCustomerScorecard,
} from "@dana/Services/DanaMenuService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import toggleMyaccountMenu from "@dana/Store/Data/MyAccountMenu/Handlers/ToggleMyAccountMenuHandler";
import { SoldToAddress } from "@dana/Types/ApiModels";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getUrl } from "@insite/client-framework/ServerSideRendering";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import loadAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadAccount";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps, StyledButton } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext, useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface DanaMenuItemStyles {
    listItemStyleMyAccount?: ClickablePresentationProps;
    menuItemMainWrapper?: InjectableCss;
    childrenMenuItem?: InjectableCss;
    modal?: ModalPresentationProps;
    form?: InjectableCss;
    container?: GridContainerProps;
    modalGridItem?: GridItemProps;
    h2?: TypographyPresentationProps;
    key?: TypographyPresentationProps;
    generateButton?: ButtonPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    salesRepwrapper?: InjectableCss;
    salesRepDetails?: InjectableCss;
    salesRepName?: TypographyPresentationProps;
    salesRepEmail?: LinkPresentationProps;
    salesRepContact?: LinkPresentationProps;
}
export const danaMenuItemStyles: DanaMenuItemStyles = {
    listItemStyleMyAccount: {
        css: css`
            background: ${themeBackgrounds.white};
            padding: 8px;
            width: 100%;

            span {
                color: ${themeColors.primary.danaBlue};
            }
            .right-chevrondown {
                svg {
                    path {
                        fill: ${themeColors.primary.danaBlue};
                    }
                }
            }

            &:hover {
                background: ${themeBackgrounds.offWhite};
                text-decoration: none;
                span {
                    color: ${themeColors.secondary.danaDarkBlue};
                }

                .right-chevrondown {
                    svg {
                        path {
                            fill: ${themeColors.primary.danaBlue};
                        }
                    }
                }
            }

            &:focus,
            &:focus-visible {
                background: ${themeBackgrounds.lightGray};
                text-decoration: none;
                outline: none;
                border-radius: 0px;

                span {
                    color: ${themeColors.primary.richBlack};
                }
            }

            .right-chevrondown {
                svg {
                    path {
                        fill: ${themeColors.primary.danaBlue};
                    }
                }
            }
        `,
    },

    menuItemMainWrapper: {
        css: css`
            background: ${themeBackgrounds.white};

            &.border-btm {
                border-bottom: 1px solid ${themeBackgrounds.lightGray};
            }
        `,
    },

    childrenMenuItem: {
        css: css`
            > .menu-item {
                .menu-link {
                    padding-left: 16px;
                }

                &:hover {
                    background: ${themeBackgrounds.offWhite};
                }

                &:focus,
                &:focus-visible {
                    background: ${themeBackgrounds.lightGray};
                    text-decoration: none;
                    outline: none;
                    border-radius: 0px;

                    .menu-link {
                        background: ${themeBackgrounds.lightGray};
                        width: 100%;
                    }

                    span {
                        color: ${themeColors.primary.richBlack};
                    }
                }
            }
        `,
    },
    modal: {
        size: 768,
    },
    container: { gap: 15 },
    modalGridItem: {
        css: css`
            justify-content: flex-center;
        `,
        width: 12,
    },
    h2: {
        variant: "h2",
        css: css`
            font-size: 1.1rem;
            font-weight: 500;
            margin-right: 1rem;
            line-height: 1.5rem;
        `,
    },
    key: {
        variant: "p",
        css: css`
            line-height: 1.5rem;
        `,
    },
    generateButton: { variant: "primary" },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    form: {
        css: css`
            display: none;
        `,
    },
    salesRepwrapper: {
        css: css`
            position: relative;
            width: 100%;
            background-size: cover;
            background-position: center;
            border-radius: 8px;
            cursor: pointer;
        `,
    },
    salesRepDetails: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
        `,
    },
    salesRepName: {
        weight: fontWeights.semiBold,
        css: css`
            margin-bottom: 4px;
        `,
    },
    salesRepEmail: {
        css: css`
            margin-bottom: 4px;
        `,
    },
    salesRepContact: {
        css: css`
            margin-bottom: 4px;
        `,
    },
};
export type OwnProps = {
    item: MappedLink;
    hasChildren?: boolean;
};

const mapStateToProps = (state: ApplicationStateDana) => {
    const session = getSession(state);
    return {
        billToId: session?.billToId,
        shipToId: session?.shipToId,
        soldto:
            session?.properties?.soldToAddress &&
                session?.properties?.soldToAddress !== "" &&
                session?.properties?.soldToAddress !== undefined
                ? (JSON.parse(session?.properties?.soldToAddress) as SoldToAddress)
                : undefined,
        salesRep: session?.properties?.salesRepDetails ? JSON.parse(session.properties.salesRepDetails) : undefined
    };
};

const mapDispatchToProps = {
    signOut,
    toggleMyaccountMenu,
    loadAccount,
};
type DanaMenuItemProps = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;
const styles = danaMenuItemStyles;
const DanaMenuItem = ({
    item,
    hasChildren,
    signOut,
    toggleMyaccountMenu,
    soldto,
    billToId,
    shipToId,
    loadAccount,
    salesRep
}: DanaMenuItemProps) => {
    const [open, setOpen] = useState(false);
    const [openScoreCardModal, setopenScoreCardModal] = useState<boolean>(false);
    const [openPriceListModal, setOpenPriceListModal] = useState<boolean>(false);
    const [openCoreReturnstModal, setOpenCoreReturnsModal] = useState<boolean>(false);
    const [openCoopModal, setOpenCoopModal] = useState<boolean>(false);
    const [openSalesRepModal, setOpenSalesRepModal] = useState<boolean>(false);
    const [openLeadTimesModal, setOpenLeadTimesModal] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean | undefined>(false);
    const [isCoreReturnsLoading, setIsCoreReturnsLoading] = useState<boolean | undefined>(false);
    const [isPriceListLoading, setIsPriceListLoading] = useState<boolean | undefined>(false);
    const [isLeadTimesLoading, setIsLeadTimesLoading] = useState<boolean | undefined>(false);
    const [isCoopLoading, setIsCoopLoading] = useState<boolean | undefined>(false);
    const [isScorecardLoading, setIsScorecardLoading] = useState<boolean | undefined>(false);
    const [scorecardUrl, setSorecardUrl] = useState<string | undefined>(undefined);
    const [scorecardEmailRequestId, setSorecardEmailRequestId] = useState<string | undefined>(undefined);
    const [isApiKeyOpen, setIsApiKeyOpen] = useState<boolean | undefined>(false);
    const [hasGenerated, setHasGenerated] = useState<boolean | undefined>(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [apiKey, setApiKey] = useState<string | undefined>("");
    const [modalType, setModalType] = useState<string>("");
    const [isFuture, setIsFuture] = useState<boolean>(false);
    const [leadTimeRequestId, setLeadTimeRequestId] = useState<string | undefined>(undefined);
    const [priceListRequestId, setPriceListRequestId] = useState<string | undefined>(undefined);
    const [scorecardRequestId, setScorecardRequestId] = useState<string | undefined>(undefined);
    const [coreReturnsData, setCoreReturnsData] = useState<DanaCoreReturnsData | undefined>(undefined);
    const [coopData, setCoopData] = useState<DanaCoopData | undefined>(undefined);
    const coreReturnsFormRef = useRef<HTMLFormElement>(null);
    const coopFormRef = useRef<HTMLFormElement>(null);
    const url = IS_SERVER_SIDE ? getUrl()! : window.location;

    let leadTimeIntervalId: NodeJS.Timeout | undefined;
    let priceListIntervalId: NodeJS.Timeout | undefined;
    let scorecardIntervalId: NodeJS.Timeout | undefined;
    const toasterContext = useContext(ToasterContext);

    useEffect(() => {
        if (leadTimeRequestId) {
            leadTimeIntervalId = setInterval(() => {
                checkLeadTimes(leadTimeRequestId, soldto?.CustomerSequence ?? "").then(done => {
                    if (done && leadTimeIntervalId) {
                        clearInterval(leadTimeIntervalId);
                        setLeadTimeRequestId(undefined);
                        setOpenLeadTimesModal(false);
                        setIsLeadTimesLoading(false);
                    }
                });
            }, 20000);
        } else if (priceListRequestId) {
            priceListIntervalId = setInterval(() => {
                checkPriceList(priceListRequestId, soldto?.CustomerSequence ?? "").then(done => {
                    if (done && priceListIntervalId) {
                        clearInterval(priceListIntervalId);
                        setPriceListRequestId(undefined);
                        setOpenPriceListModal(false);
                        setIsPriceListLoading(false);
                    }
                });
            }, 20000);
        } else if (scorecardRequestId) {
            scorecardIntervalId = setInterval(() => {
                checkCustomerScorecard(scorecardRequestId, soldto?.CustomerSequence ?? "").then(done => {
                    if (done) {
                        clearInterval(scorecardIntervalId);
                        setScorecardRequestId(undefined);
                        setSorecardUrl(done);
                        setIsScorecardLoading(false);
                    }
                });
            }, 20000);
        } else if (coreReturnsData && coreReturnsFormRef?.current) {
            coreReturnsFormRef.current.submit();
        } else if (coopData && coopFormRef?.current) {
            coopFormRef.current.submit();
        }
    }, [leadTimeRequestId, priceListRequestId, scorecardRequestId, scorecardUrl, coreReturnsData, coopData]);

    const closeApiKeyModalHandler = (event: React.SyntheticEvent<Element, Event>) => {
        setIsApiKeyOpen(false);
    };

    const handleCoreReturns = () => {
        setOpenCoreReturnsModal(true);
        setIsCoreReturnsLoading(true);
        getCoreReturnsToken().then((response: DanaCoreReturnsData | undefined) => {
            if (response) {
                setCoreReturnsData(response);
            }
        });
    };

    const handleCoop = () => {
        setOpenCoopModal(true);
        setIsCoopLoading(true);
        getCoopToken().then((response: DanaCoopData | undefined) => {
            if (response) {
                setCoopData(response);
            }
        });
    };

    const handleFindMyRep = () => {
        setOpenSalesRepModal(true);
    };

    const closeSalesRepModal = () => {
        setOpenSalesRepModal(false);
    };

    const handleDownloadLeadTimes = () => {
        setOpenLeadTimesModal(true);
        setIsLeadTimesLoading(true);
        toasterContext.addToast({
            body: translate("Published Lead time download has started."),
            messageType: "success",
            isFocusAfterMount: false,
        });
        downloadLeadTimes().then(requestid => {
            if (requestid) {
                setLeadTimeRequestId(requestid);
            }
        });
    };

    const handleDownloadPriceList = (isFuture: boolean) => {
        setOpenPriceListModal(true);
        setIsFuture(isFuture);
    };

    const handleCloseDownloadPriceList = () => {
        setOpenPriceListModal(false);
    };

    const handleOpenScoreCardModal = (modalType: string) => {
        setIsScorecardLoading(true);
        setopenScoreCardModal(true);
        setModalType(modalType);
        getCustomerScorecard().then(requestId => {
            if (requestId) {
                setScorecardRequestId(requestId);
                setSorecardEmailRequestId(requestId);
            }
        });
    };

    const closeScoreCardModal = () => {
        setopenScoreCardModal(false);
        setModalType("");
    };

    const getGenApiKey = async () => {
        setIsLoading(true);
        let apiKeyResult = await fetch(`/api/v1/dana/generateKey?billToId=${shipToId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "text/plain",
            },
            body: JSON.stringify({ billToId: shipToId ?? '' }),
        });
        if (apiKeyResult.ok) {
            let apiKeyString = await apiKeyResult.text();
            if (apiKeyString !== undefined && apiKeyString !== "") {
                setHasGenerated(true);
                setApiKey(apiKeyString.replace(new RegExp('\\"', "g"), ""));
            }
        } else {
            setErrorMessage("Could not generate new API Key for current user.");
        }
        setIsLoading(false);
    };

    const getExistingKey = async () => {
        if (shipToId !== undefined) {
            let apiKeyResult = await fetch(`/api/v1/dana/getApiKey?billToId=${shipToId}`, {
                method: "GET",
                headers: {
                    Accept: "text/plain",
                },
            });
            if (apiKeyResult.ok) {
                let apiKeyString = await apiKeyResult.text();
                if (apiKeyString !== undefined && apiKeyString !== "") {
                    setHasGenerated(true);
                    setApiKey(apiKeyString.replace(new RegExp('\\"', "g"), ""));
                    setIsLoading(false);
                    return true;
                }
            }
            setIsLoading(false);
            return false;
        }
    };

    const handleApiKey = () => {
        setIsApiKeyOpen(true);
        getExistingKey().then(response => { });
    };

    const handleClick = (e: React.MouseEvent) => {
        if (hasChildren) {
            e.preventDefault();
            e.stopPropagation();
            setOpen(prev => !prev);
        }
    };

    const generateKey = () => {
        getGenApiKey();
    };

    const scoreCardModalTitle =
        modalType === "Single Account"
            ? translate("Customer Scorecard: Single Account")
            : translate("Customer Scorecard: Buying Group");

    return (
        <StyledWrapper
            className={
                ["Settings", "DownloadPriceList", "Download Price List"].includes(item.title.trim())
                    ? "menu-item border-btm"
                    : "menu-item"
            }
            {...styles.menuItemMainWrapper}
        >
            <Clickable
                target={item.openInNewWindow ? "_blank" : "_self"}
                {...styles.listItemStyleMyAccount}
                href={!hasChildren ? item.url : ""}
                onClick={(e: React.MouseEvent) => {
                    if (hasChildren) {
                        handleClick(e);
                        return;
                    }
                    if (item?.type === "signouttype") {
                        signOut();
                    } else if (item?.url === "/MyAccount/CustomerScorecard/SingleAccount") {
                        e.preventDefault();
                        handleOpenScoreCardModal("Single Account");
                    } else if (item?.url === "/MyAccount/CustomerScorecard/BuyingGroup") {
                        e.preventDefault();
                        handleOpenScoreCardModal("Buying Group");
                    } else if (item?.url === "/MyAccount/CoOp") {
                        e.preventDefault();
                        handleCoop();
                    } else if (item?.url === "/MyAccount/FindMyRepresentative") {
                        e.preventDefault();
                        handleFindMyRep();
                    } else if (item?.url === "/MyAccount/CoreReturn") {
                        e.preventDefault();
                        handleCoreReturns();
                    } else if (item?.url === "/MyAccount/DownloadLeadTimes") {
                        e.preventDefault();
                        handleDownloadLeadTimes();
                    } else if (item?.url === "/MyAccount/DownloadPriceList/CurrentPriceList") {
                        e.preventDefault();
                        handleDownloadPriceList(false);
                    } else if (item?.url === "/MyAccount/DownloadPriceList/FuturePriceList") {
                        e.preventDefault();
                        handleDownloadPriceList(true);
                    } else if (item?.url === "/MyAccount/APIDeveloper/apikey") {
                        e.preventDefault();
                        handleApiKey();
                    }
                    toggleMyaccountMenu({ isOpen: false });
                }}
                className={`menu-link ${hasChildren ? "menu-parent" : ""}`}
            >
                {item?.type === "pricetoggletype" ? (
                    <ShowPriceSettingSwitch />
                ) : (
                    <>
                        <MenuItemText hasChildren={hasChildren} data-test-selector="menuItemText">
                            {translate(item.title)}
                        </MenuItemText>
                        {hasChildren && (
                            <Icon
                                size={16}
                                src={open ? ChevronUp : ChevronDown}
                                className={open ? "right-chevronup" : "right-chevrondown"}
                            />
                        )}
                    </>
                )}
            </Clickable>

            {hasChildren && open && (
                <StyledWrapper className="menu-children styles-wrapper" {...styles.childrenMenuItem}>
                    {item.children!.map((child: MappedLink, idx: any) => (
                        <DanaMenuItem
                            toggleMyaccountMenu={toggleMyaccountMenu}
                            signOut={signOut}
                            loadAccount={loadAccount}
                            billToId={billToId}
                            key={idx}
                            item={child}
                            soldto={soldto}
                            shipToId={shipToId}
                            salesRep={salesRep}
                        />
                    ))}
                </StyledWrapper>
            )}

            {/* Customer Scorecard Modal */}
            <Modal
                headline={scoreCardModalTitle}
                isOpen={openScoreCardModal}
                handleClose={closeScoreCardModal}
                {...styles.modal}
            >
                {isScorecardLoading ? (
                    <StyledWrapper {...styles.centeringWrapper}>
                        <LoadingSpinner {...styles.spinner} />
                    </StyledWrapper>
                ) : (
                    <CustomerScoreCard url={scorecardUrl} requestId={scorecardEmailRequestId} />
                )}
            </Modal>
            <Modal
                headline={translate("Logging into Core Returns")}
                isOpen={openCoreReturnstModal}
                isCloseable={false}
                {...styles.modal}
            >
                <>
                    {isCoreReturnsLoading ? (
                        <StyledWrapper {...styles.centeringWrapper}>
                            <LoadingSpinner {...styles.spinner} />
                        </StyledWrapper>
                    ) : (
                        <></>
                    )}
                    <form ref={coreReturnsFormRef} action={coreReturnsData?.url} method="post" {...styles.form}>
                        <input type="hidden" id="email" name="email" value={coreReturnsData?.email} />
                        <input type="hidden" id="token" name="token" value={coreReturnsData?.token} />
                        <input type="hidden" id="dealerCode" name="dealerCode" value={coreReturnsData?.dealerCode} />
                        <input type="hidden" id="clientId" name="clientId" value={coreReturnsData?.clientId} />
                        <input
                            type="hidden"
                            id="clientSecret"
                            name="clientSecret"
                            value={coreReturnsData?.clientSecret}
                        />
                    </form>
                </>
            </Modal>
            <Modal
                headline={translate("Logging into Co-op")}
                isOpen={openCoopModal}
                isCloseable={false}
                {...styles.modal}
            >
                <>
                    {isCoopLoading ? (
                        <StyledWrapper {...styles.centeringWrapper}>
                            <LoadingSpinner {...styles.spinner} />
                        </StyledWrapper>
                    ) : (
                        <></>
                    )}
                    <form ref={coopFormRef} action={coopData?.url} method="post" {...styles.form}>
                        <input type="hidden" id="accessToken" name="accessToken" value={coopData?.accessToken} />
                        <input
                            type="hidden"
                            id="custom_sso_domain_name"
                            name="custom_sso_domain_name"
                            value={url?.hostname}
                        />
                        <input type="hidden" id="email" name="email" value={coopData?.email} />
                        <input type="hidden" id="first_name" name="first_name" value={coopData?.first_name} />
                        <input type="hidden" id="last_name" name="last_name" value={coopData?.last_name} />
                    </form>
                </>
            </Modal>
            <Modal
                headline={translate("My Sales Representative")}
                isOpen={openSalesRepModal}
                handleClose={closeSalesRepModal}
            >
                <StyledWrapper {...styles.salesRepwrapper}>
                    {/* If part */}
                    {(salesRep !== undefined && salesRep?.email !== null) && (
                        <StyledWrapper {...styles.salesRepDetails}>
                            <Typography {...styles.salesRepName}>{salesRep?.name}</Typography>
                            <Link href={`mailto:${salesRep?.email}`} {...styles.salesRepEmail}>
                                {salesRep?.email}
                            </Link>
                            <Link href={`tel:${salesRep?.phone}`} {...styles.salesRepContact}>
                                {salesRep?.phone}
                            </Link>
                        </StyledWrapper>
                    )}
                    {/* End If part */}

                    {/* Elase Part */}
                    {(salesRep === undefined || salesRep?.email === null) && (<div>
                        <Typography>{siteMessage("ProductDetailPage_SalesRepNotAssigned_Message")}</Typography>
                    </div>)}
                    {/* End Else part */}
                </StyledWrapper>
            </Modal>
            <Modal
                headline={translate("Downloading lead times")}
                isOpen={openLeadTimesModal}
                isCloseable={false}
                {...styles.modal}
            >
                <>
                    {isLeadTimesLoading ? (
                        <StyledWrapper {...styles.centeringWrapper}>
                            <LoadingSpinner {...styles.spinner} />
                        </StyledWrapper>
                    ) : (
                        <></>
                    )}
                </>
            </Modal>
            <Modal
                headline={translate("Download Price List")}
                isOpen={openPriceListModal}
                isCloseable={isPriceListLoading ? false : true}
                {...styles.modal}
                handleClose={handleCloseDownloadPriceList}
            >
                {isPriceListLoading ? (
                    <StyledWrapper {...styles.centeringWrapper}>
                        <LoadingSpinner {...styles.spinner} />
                    </StyledWrapper>
                ) : (
                    <>
                        <Typography variant="h5">{translate("Terms and Conditions:")}</Typography>
                        <Typography variant="p">
                            {translate(
                                "Dana's Aftermarket group publishes net price and takes every effort to assure its accuracy. However, emergency order premiums, surcharges, tariffs, freight, and other charges may apply to final pricing. Your placement of an order, is based on final pricing applied at the time of order your entry and is considered your acceptance and agreement of Dana's final pricing. Availability or advertising of your net pricing does not constitute a firm offer or commitment to sell at that price. Pricing is subject to change without notice to the customer. Pricing is Dana confidential information and is intended for the sole use of the customer. Use of this file by unauthorized persons is strictly prohibited. Publication, distribution, dissemination, or sharing of this file is strictly prohibited under penalty of law.",
                            )}
                        </Typography>
                        <Button
                            title={translate("Confirm")}
                            onClick={() => {
                                setIsPriceListLoading(true);
                                toasterContext.addToast({
                                    body: translate("Price List download has started."),
                                    messageType: "success",
                                    isFocusAfterMount: true,
                                });
                                downloadPriceList(isFuture).then(requestid => {
                                    if (requestid) {
                                        setPriceListRequestId(requestid);
                                    }
                                });
                            }}
                        >
                            {translate("Confirm")}
                        </Button>
                    </>
                )}
            </Modal>
            <Modal
                {...styles.modal}
                handleClose={closeApiKeyModalHandler}
                headline={translate("Developer Portal API Key")}
                isOpen={isApiKeyOpen}
                data-test-selector="apiKeyModal"
            >
                {isLoading ? (
                    <StyledWrapper {...styles.centeringWrapper}>
                        <LoadingSpinner {...styles.spinner} />
                    </StyledWrapper>
                ) : errorMessage === undefined ? (
                    <GridContainer {...styles.container}>
                        {hasGenerated ? (
                            <GridItem {...styles.modalGridItem}>
                                <Typography {...styles.h2}>{translate("API Key")}:</Typography>
                                <Typography {...styles.key}>{apiKey}</Typography>
                            </GridItem>
                        ) : (
                            <GridItem {...styles.modalGridItem}>
                                <Button
                                    {...styles.generateButton}
                                    data-test-selector="createUserModal_createUserButton"
                                    type="submit"
                                    onClick={generateKey}
                                >
                                    {translate("Generate API Key")}
                                </Button>
                            </GridItem>
                        )}
                    </GridContainer>
                ) : (
                    <GridItem {...styles.modalGridItem}>
                        <Typography {...styles.h2}>{translate("Error")}:</Typography>
                        <Typography {...styles.key}>{errorMessage}</Typography>
                    </GridItem>
                )}
            </Modal>
        </StyledWrapper>
    );
};
export default connect(mapStateToProps, mapDispatchToProps)(DanaMenuItem);
